<template>
    <div class="publicProfile row align-items-center justify-content-center">
        <div class="col-12 d-flex align-items-center justify-content-between mb-4">
            <router-link class="d-flex align-items-center backBtn medium disabled" :to="{name : 'create_broker_account4',params:{'id':this.$route.params.id}}">
                <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{$t('decleration.text1')}}
            </router-link>
        </div>
        <div class="col-12 col-md-8">
            <div class="mainTitle text-center mb-5" v-if="Failfor7Days()">
                <h3 class="mb-3 clash">{{$t('decleration.text26')}}</h3>
                <vue3-flip-countdown  :deadline="test_finish_date" v-if="test_finish_date"/>
                <p class="mt-4">{{$t('decleration.text27')}}</p>
                <p>{{$t('decleration.text28')}}</p>
            </div>
        </div>
        <div class="col-12 col-md-8" v-if="!Failfor7Days()">
            <div class="mainTitle text-center mb-5">
                <img src="/assets/images/wrong48.svg" :alt="$t('decleration.text24')" :title="$t('decleration.text24')" />
                <h3 class="my-4 clash">{{$t('decleration.text24')}}</h3>
                <p>{{$t('decleration.text25')}}</p>
                <p class="mb-4">{{$t('decleration.text25a')}}</p>
            </div>
        </div>
    </div>
</template>
<script>
import { useMainStore } from "@/store";
import moment from 'moment';
    export default{
        setup() {
            const store = useMainStore();
            return { store };
        },
        data(){
            return {
                test_finish_date : ''
            }
        },
        methods:{
            Failfor7Days(){
                if(this.store.brokerStatusList?.stepsStatus?.length){
                    let data = this.store.brokerStatusList?.stepsStatus.find(i => i?.step == 'Questionnaire');
                    if(data?.questionnaireDetails?.data){
                        this.test_finish_date = moment(data?.questionnaireDetails?.data?.test_date).add(7, 'days').format('YYYY-MM-DD hh:mm:ss');
                        if(parseInt(data?.questionnaireDetails?.data?.total_points) < 2){
                            return true
                        }else{
                            return false
                        }
                    }else{
                        return false
                    }
                }
            }
        }
    }
</script>